// You can write more code here

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
import scopeAndSequence from '@/common/data/scopeAndSequence.json';
import {
  GameInstance,
  getStudent,
} from '@/game/GameComponents/PhaserGame/GameInstance';
/* END-USER-IMPORTS */

export default class Portal extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // portal
    const portal = scene.add.container(0, 0);
    portal.setInteractive(
      new Phaser.Geom.Rectangle(-28, -28, 56, 56),
      Phaser.Geom.Rectangle.Contains,
    );
    this.add(portal);

    // portal_body
    const portal_body = scene.add.sprite(0, 0, 'portal_spritesheet', 0);
    portal_body.setInteractive(
      new Phaser.Geom.Rectangle(0, 0, 28, 28),
      Phaser.Geom.Rectangle.Contains,
    );
    portal_body.scaleX = 2;
    portal_body.scaleY = 2;
    portal.add(portal_body);

    this.portal_body = portal_body;

    /* START-USER-CTR-CODE */
    this.scene.events.once('scene-awake', this.refresh, this);
    this.scene.events.once('scene-awake', this.create, this);
    this.scene.events.on('resume', this.refresh, this);
    this.scene.events.once('destroy', this.handleShutdown, this);
    this.scene.events.once('shutdown', this.handleShutdown, this);
    /* END-USER-CTR-CODE */
  }

  private portal_body: Phaser.GameObjects.Sprite;

  /* START-USER-CODE */
  public callback?: (portal: Portal) => void;

  create() {
    // load portal animation.
    this.scene.load.spritesheet(
      'portal_spritesheet',
      'game_assets/vfx/Super Pixel Effects Pack 1/spritesheet/fx1_aura_energy_small_violet/spritesheet.png',
      { frameWidth: 28, frameHeight: 28 },
    );
    this.scene.load.animation(
      'portal-anim',
      'game_assets/animations/portal/portal-anim.json',
    );
    this.scene.load.once('complete', () => {
      this.scene.anims.create({
        key: 'portal-anim',
        frames: this.scene.anims.generateFrameNumbers('portal_spritesheet', {
          start: 0,
          end: 9,
        }),
        frameRate: 8,
        repeat: -1,
      });
      this.portal_body.play('portal-anim');
    });
    this.scene.load.start();
  }

  refresh() {
    const { enabledGames, gamesProgress, completedPlaythroughs } =
      GameInstance.instance.getActiveLevelProgress();
    const isAllGamesCompleted = enabledGames.every(
      (game) => (gamesProgress[game]?.timesPlayed ?? 0) > completedPlaythroughs,
    );

    // TEMP FIX TO STOP USERS GOING PAST THE MAX LEVEL.
    const maxLevel = scopeAndSequence.levels.length - 1;
    if (getStudent().level - 1 >= maxLevel) {
      this.setVisible(false);
      return;
    }

    this.setVisible(isAllGamesCompleted);

    if (isAllGamesCompleted) {
      // Setup interaction.
      this.portal_body.setInteractive({ cursor: 'pointer' });
      this.portal_body.on('pointerdown', () => {
        this.callback?.(this);
      });
    }
  }

  handleShutdown() {
    this.scene?.events.off('scene-awake', this.refresh, this);
    this.scene?.events.off('resume', this.refresh, this);
    this.scene?.events.off('destroy', this.handleShutdown, this);
    this.scene?.events.off('shutdown', this.handleShutdown, this);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
